import {
    AddressAmabisMode,
    AddressAmabisProps,
} from '@axa-fr-axion/input-amabis';
import { IfLayout } from '@axa-fr-axion/layouts';
import { useEffect, useState } from 'react';
import { Address } from './address';
import { AddressInputProps } from './AddressInput.interface';
import styles from './AddressInput.module.css';
import classNames from 'classnames';
import { Direction } from '@axafr-btc-ds/tooltip';

export const POSTAL_CODE_LENGTH = 5;
export function AddressInput({ onChange, data }: AddressInputProps) {
    const defaultMode = data?.address ? 'Display' : 'Search';
    const [ mode, setMode ] = useState<AddressAmabisMode>(defaultMode);

    const handleOnChange: AddressAmabisProps['onChange'] = (value) => {
        const address = value.address;
        onChange?.({ address: address?.street, city: address?.city, postalCode: address?.postalCode },
            getValidity({ ...value.address, address: value.address?.street }));
        setMode(value.mode ?? 'Search');
    };
    const getValidity = (addressProps: AddressInputProps['data']) => {
        return addressProps?.address && addressProps.city && addressProps.postalCode?.length === POSTAL_CODE_LENGTH ? 'Valid' : 'Invalid';
    };

    useEffect(() => {
        if (data) {
            onChange?.(data, getValidity(data));
        }
    }, []);

    return (
        <>
            <IfLayout className={ classNames(styles.inputHeight, styles.ifLayout) }>
                <Address
                    fieldsProps={ {
                        autoCompletion: {
                            tooltipDirection: Direction.up,
                        },
                    } }
                    displayClassName={ styles.address }
                    styleName={ styles.address }
                    address={ {
                        value: '',
                        street: data?.address,
                        city: data?.city,
                        postalCode: data?.postalCode } }
                    mode={ mode }
                    onChange={ handleOnChange }
                />
            </IfLayout>
        </>
    );
}

export default AddressInput;
